<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="rb_custname"
      placeholder="输入客户、录入人进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.rb_id"
        :to="'/money/receipt_apply/'+item.rb_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.rb_custname}}</p>
          <p class="list-item-muted">{{item.rb_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.rb_rdamount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.rb_status!='已审核'}"
          >{{item.rb_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('rb_rdamount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    // const me = this, beforeChange = me.beforeFilterChange
    return {
      listUrl: "/api/money/recbackapply/list",
      filters: [
        {
          type: "date",
          name: "rb_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          // beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            // {
            //   value: 1,
            //   label: "未退款",
            //   condition: "sl_custid>0 and ifnull(sl_namount,0)<0 and ((sl_kind IN ('SALERETURN','GOODSSEND','销售退货单')  and abs(ifnull(sl_auditbillamount,0))>(abs(ifnull(sl_yamount,0))+abs(ifnull(sl_lockamount,0))) and ifnull(sl_auditbillamount,0)<>0 ) or (sl_kind IN ('应收调账单','应收转应收','期初余额')))",
            //   mode: "CUST"
            // },
            {
              value: 1,
              label: "待退款",
              condition: "rb_statuscode='AUDITED' and ifnull(rb_payamount,0)<ifnull(rb_amount,0)"
            },
            {
              value: 2,
              label: "已退款",
              condition: "rb_statuscode='AUDITED' and ifnull(rb_payamount,0)=ifnull(rb_amount,0)"
            },
            {
              value: 3,
              label: "背书转让",
              condition: " rb_statuscode='AUDITED' and abs(rb_amount)>abs(ifnull(rb_payamount,0))"
            },
          ]
        }
      ]
    };
  },
  // methods: {
  //   beforeFilterChange(filter, filterBar, next) {
  //     this.listUrl = filter.value == 1 ? '/api/money/subledger/list' : '/api/money/recbackapply/list'
  //     this.filters[0].name = filter.value == 1 ? 'sl_date' : 'rb_date'
  //     filterBar.initConfig()
  //     next()
  //   },
  // }
};
</script>